const state = {
    // Show/hide
    shareWishlist: false,
    changePassword: false,
    editAddress: false,
    emailCart: false,
    chooseShipCountry: false,
    // Supporting state
    captchaLoaded: false,
    accountAddress: null
};

// getters
const getters = {
    // Show/hide
    shareWishlist: state => state.shareWishlist,
    changePassword: state => state.changePassword,
    editAddress: state => state.editAddress,
    emailCart: state => state.emailCart,
    // Supporting state
    captchaLoaded: state => state.captchaLoaded,
    accountAddress: state => state.accountAddress
};

// actions
const actions = {
    openModal({ dispatch, commit }, { name, captcha }) {
        if (captcha) {
            dispatch("loadCaptcha");
        }
        commit("modal" + name.charAt(0).toUpperCase() + name.slice(1), true);
    },
    editAddress({ commit }, accountAddress) {
        commit("setAccountAddress", accountAddress);
        commit("modalEditAddress", true);
    },
    loadCaptcha({ state, commit }) {
        if (!state.captchaLoaded) {
            commit("setCaptchaLoaded", true);
            const s = document.createElement("script");
            s.setAttribute(
                "src",
                "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
            );
            s.async = true;
            s.defer = true;
            document.body.appendChild(s);
        }
    }
};

// mutations
const mutations = {
    // Show/hide
    modalShareWishlist(state, value) {
        state.shareWishlist = value;
    },
    modalChangePassword(state, value) {
        state.changePassword = value;
    },
    modalEmailCart(state, value) {
        state.emailCart = value;
    },
    modalEditAddress(state, value) {
        state.editAddress = value;
    },
    modalChooseShipCountry(state, value) {
        state.chooseShipCountry = value;
    },
    // supporting state
    setCaptchaLoaded(state, value) {
        state.captchaLoaded = value;
    },
    setAccountAddress(state, value) {
        state.accountAddress = value;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
